
import { Component, Prop, Vue } from "vue-property-decorator";
import PModal from "@/components/look/PModal.vue";
import { IThirdcode } from "@/entities";
import { extend, ValidationObserver, ValidationProvider } from "vee-validate";
import Multiselect from "vue-multiselect";

@Component({
  name: "add-edit-thirdcode-modal",
  components: {
    Multiselect,
    PModal,
    ValidationObserver,
    ValidationProvider,
  },
})
export default class AddEditThirdcodeModal extends Vue {
  @Prop({ required: true })
  thirdcodeList!: IThirdcode[];
  @Prop({ required: false })
  thirdcode?: IThirdcode;

  private system: string | undefined = "";
  private code: string | undefined = "";

  constructor() {
    super();
  }

  async mounted(): Promise<void> {
    extend("system_unique", {
      validate: async () => {
        if (this.system) {
          return !this.thirdcodeList?.find(
            (th) => this.thirdcode !== th && th.system === this.system
          );
        }
        return true;
      },
      message: () => this.$t("validation.messages.systemNameAlreadyExists") as string,
    });
  }

  initData(): void {
    this.system = this.thirdcode?.system;
    this.code = this.thirdcode?.code;
  }

  async onSubmit(): Promise<void> {
    if (this.thirdcode) {
      this.thirdcode.system = this.system;
      this.thirdcode.code = this.code;
    } else {
      const newThirdcode = {
        system: this.system,
        code: this.code,
      } as IThirdcode;

      this.thirdcodeList.push(newThirdcode);
    }
    this.$bvModal.hide("addEditThirdcodeModal");
  }
}
